import axios from "axios";
import { cmsHeaders } from "../exports/exports";

export const fetchgalleryHeader = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/gallery-header`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error");
  }
};

export const fetchgalleryImages = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/galley-album`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
